module.exports = __webpack_public_path__ + "static/img/Rokid Glasses.ac8333ef.png";